/**
 * mock.ts — synthetic Beziehungsnetz fixture (Story UI-U8). No real PII.
 *
 * A firma ego graph with a Mutter, two Schwestern, two Töchter, a Person, and a
 * Partner — enough to exercise every layout band + the filters. Used in mock mode
 * (VITE_DATA_MODE unset in dev/tests) so the Struktur tab renders standalone.
 */

import type { BeziehungsnetzDto } from '@brokly/shared';

export function mockBeziehungsnetz(subjectId: string): BeziehungsnetzDto {
  return {
    subject_id: subjectId,
    entities: [
      { id: subjectId, kind: 'firma', name: 'Basler Chemie AG', uid: 'CHE-105.412.889', kanton: 'BS', firma_id: subjectId },
      { id: 'mutter-1', kind: 'firma', name: 'Helvetia Holding AG', uid: 'CHE-116.284.019', kanton: 'ZH', firma_id: 'mutter-1' },
      { id: 'schwester-1', kind: 'firma', name: 'Rhein Chemie AG', uid: 'CHE-105.887.220', kanton: 'BS', firma_id: 'schwester-1' },
      { id: 'schwester-2', kind: 'firma', name: 'Alpin Pharma AG', uid: 'CHE-208.114.552', kanton: 'ZG', firma_id: 'schwester-2' },
      { id: 'tochter-1', kind: 'firma', name: 'Basler Labor GmbH', uid: 'CHE-302.667.109', kanton: 'BS', firma_id: 'tochter-1' },
      { id: 'tochter-2', kind: 'firma', name: 'ChemLog AG', uid: 'CHE-411.220.774', kanton: 'BL', firma_id: 'tochter-2' },
      { id: 'person-1', kind: 'person', name: 'Roth Anna', uid: null, kanton: null, firma_id: 'person-1' },
      { id: 'uid:CHE-233.618.940', kind: 'firma', name: 'TechPart Solutions GmbH', uid: 'CHE-233.618.940', kanton: 'AG', firma_id: null },
    ],
    relations: [
      { id: 'r-mutter', from: 'mutter-1', to: subjectId, kategorie: 'mutter', rel_type: 'mutter_tochter', source: 'uid_public_services', label: '72 % Beteiligung' },
      { id: 'r-schw1', from: 'schwester-1', to: subjectId, kategorie: 'schwester', rel_type: 'schwester', source: 'uid_public_services', label: null },
      { id: 'r-schw2', from: 'schwester-2', to: subjectId, kategorie: 'schwester', rel_type: 'schwester', source: 'uid_public_services', label: null },
      { id: 'r-t1', from: subjectId, to: 'tochter-1', kategorie: 'tochter', rel_type: 'mutter_tochter', source: 'uid_public_services', label: '100 %' },
      { id: 'r-t2', from: subjectId, to: 'tochter-2', kategorie: 'tochter', rel_type: 'mutter_tochter', source: 'uid_public_services', label: '80 %' },
      { id: 'r-person', from: 'person-1', to: subjectId, kategorie: 'person', rel_type: 'inhaber', source: 'manual', label: '40 % · Aktionärin' },
      { id: 'r-partner', from: 'uid:CHE-233.618.940', to: subjectId, kategorie: 'partner', rel_type: 'other', source: 'manual', label: 'Kooperation IT' },
    ],
  };
}
